function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M206 226.7h.3c23.5-.2 42.4-19.2 42.5-42.6V72.6l34.8-17.3-12.7-25.4L220.2 55v129.2c0 7.8-6.3 14.1-14.1 14.1h-.1V0H28.4v255.1H0v28.3h262.9v-28.3H206v-28.4zM177.6 28.3v42.5H56.8V28.3h120.8zM56.8 99.2h120.8v155.9H56.8V99.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.5 117.3v43.3h-11.3V142H97.8v18.6H86.5v-43.3h11.3v15.6h20.4v-15.6h11.3zM133.3 164.4c0-3.7.5-5.7 7.4-9.1l3.2-1.6c2.7-1.3 4-2.1 4-3.5 0-1.5-1.4-2.3-3.8-2.3-3 0-3.8 1.2-3.9 2.5h-6.9c.5-5.3 5-7.9 11.3-7.9 6.7 0 10.8 2.9 10.8 7.5 0 4.2-3.3 5.8-8.8 8.3l-2.4 1.1c-1.3.6-1.6.9-1.7 1.6h12.9v5.6h-22.1v-2.2z"
})));